import API from "./api"

/**
 * Temp user class
 */
class User extends API{
    userinfo = {};
    domain = location.host;
    published = {};
    notice={data:[],touser:{id:0,name:''}};
    myEditor={};
    groupBlogger;
    groupBlogEditer;

    init = this.getUserStatus().then(res=>{
        this.userinfo = res.data;
        if(res.status){
            this.userinfo.userID = res.data.UserID

        }
    });
    check_is_wxc_domain(){
        return this.domain=='group1.wenxuecity.com' || this.domain=='groups.wenxuecity.com' || this.domain=='group2.wenxuecity.com' || this.domain=='local.wenxuecity.com:8080'
    }
    check_is_wxcblog_domain(){
        return this.domain=='blog1.wenxuecity.com' || this.domain=='blog.wenxuecity.com'  || this.domain=='local.wenxuecity.com:8080'
    }
    check_login(){
        if (this.check_is_wxc_domain()){
            alert("请先登录!")
            window.location.href="https://www.wenxuecity.com/members/passport.php?act=login&redirect=http://"+encodeURIComponent(this.domain)+"/group/discover"
        }
        else{
            window.location.href="/login?referer="+referer;
        }
    }

    /**
     * Login function for example
     * @param {*} email
     * @param {*} password
     */
    async signup(form){
        let email = form.email;
        let password = form.password;
        try{
            // let rs = await this.post("login", {
            //     username: username,
            //     password: password
            // });
            let res = await this.get("account/passport/user_register/?email=" + email + "&password=" + password);
            return res;
        }
        catch(e){
            // console.log(e);
            return false;
        }
    }

    /**
     * Login function for example
     * @param {*} username
     * @param {*} password
     */
    async login(username, password){

        try{
            let rs = await this.post("login", {
                username: username,
                password: password
            });
            return rs;
        }
        catch(e){
            // console.log(e);
            return false;
        }
    }

    /**
     * get user infor
     * @param userID
     */
    async getUserInfo(userID){
        try{
            let res = await this.get("account/passport/login_status/?userID="+userID);
            this.userinfo= res.data;
            return res
        }
        catch(e){
            // console.log(e);
            return false;
        }
    }

    /**
     * 获取登录用户profile
     *
     */
    async user_profile(){
        try{
            let res = await this.get("account/user/user_profile/");
            return res
        }
        catch(e){
            return false;
        }
    }

    /**
     *
     * 获取用户状态
     */
    async getUserStatus(){
        try{
            if(this.check_is_wxc_domain() || this.check_is_wxcblog_domain() ){
                //获取文学城接口
                var res = await this.get("/service/api/?format=json&func=passport&act=login_status&version=4",false);
                this.user_login_wxc_to_haiwai(res.data.haiwai_token);
            }else{
                //获取海外接口
                var res = await this.get("account/passport/login_status/");
            }

            return res
        }
        catch(e){
            return e;
        }
    }

    /**
     * 返回参加的群博
     * @returns
     */
    async getGroupBlogs(){
        let res = await this.get("blog/user/group_join_list/");
        return res
    }
    /**
     * admin 开启、关闭群博功能
     * @param {*} userID
     * @param {*} visible
     * @returns
     */
    async blogger_is_group(userID,visible){
        let res = await this.get(`/blog/admin/blogger_is_group/?userID=${userID}&visible=${visible}`);
        return res;
    }

    /**
     * 退出群博
     * @param {*} bloggerID
     * @returns
     */
    async group_join_delete(bloggerID){
        let res = await this.get("blog/user/group_join_delete/?bloggerID="+bloggerID);
        return res;
    }
    /**
     * 激活博客
     */
    async blog_register(){
        let res = await this.sendget("blog/passport/blog_register/");
        return res;
    }

    /**
     * 文学城用户sso
     * @param {文学城token} token
     */
    async user_login_wxc_to_haiwai(token){
        return await this.sendget("account/passport/user_login_wxc_to_haiwai/?token="+token);
    }

    /**
     * 获取博客设置项
     *
     */
    async blogger_profile(){
        return await this.sendget("blog/user/blogger_profile/")
    }

    /**
     * 更新博客设置项
     *
     */
    async blogger_profile_update(name,description){
        return await this.sendget("blog/user/blogger_profile_update/?name=" + name + "&description=" + description)
    }

    /**
     * 更新用户设置项
     *
     */
    async user_profile_update(username,description,country){
        return await this.sendget("account/user/user_profile_update/?username=" + username + "&description=" + description + "&country=" + country)
    }

    /**
     * 获取黑名单
     * @param {翻页时需要的参数，为当前列表的最后一个id；初始值为0} lastID
     */
    async blacklist_list(lastID){
        return await this.sendget("account/user/blacklist_list/?lastID="+lastID)
    }

    /**
     * 添加黑名单
     * @param {要拉黑的用户id} blockID
     */
    async blacklist_add(blockID){
        return await this.sendget("account/user/blacklist_add/?blockID="+blockID)
    }

    /**
     * 从黑名单中移除
     * @param {要移除的用户id} blockID
     */
    async blacklist_delete(blockID){
        return await this.sendget("account/user/blacklist_delete/?blockID="+blockID)
    }

    /**
     * 举报
     * @param {要举报的用户id} userID
     * @param {举报内容} msgbody
     */
    async report_add(userID,msgbody){
        return await this.sendget("account/user/report_add/?userID="+userID+"&msgbody="+msgbody)
    }

    /**
     * 获取我的收藏
     * @param {翻页时需要的参数，为当前列表的最后一个id；初始值为0} lastID
     */
    async bookmark_list(lastID){
        return await this.sendget("account/user/bookmark_list/?lastID="+lastID)
    }

    /**
     * 收藏、加书签
     * @param postID $postID
     */
    async bookmark_add(postID){
        return await this.sendget("account/user/bookmark_add/?postID="+postID)
    }

    /**
     * 取消收藏、取消书签
     * @param postID $postID
     */
    async bookmark_delete(postID){
        return await this.sendget("account/user/bookmark_delete/?postID="+postID)
    }
    /**
     * 获取notice-全部消息
     * @param {翻页时需要的参数，为当前列表的最后一个id；初始值为0} lastID
     */
    async notification_list(lastID){
        return await this.sendget("account/user/notification_list/?lastID="+lastID)
    }

    /**
     * 获取我收到的评论
     * @param {翻页时需要的参数，为当前列表的最后一个id；初始值为0} lastID
     */
    async my_comment_list(lastID){
        return await this.sendget("account/user/my_comment_list/?lastID="+lastID)
    }

    /**
     * 获取消息未读数
     *
     */
    async notification_unread_count(){
        let res = await this.sendget("account/user/notification_unread_count/")
        if(res.status) this.notice.data=res.data
        return res
    }

    /**
     * 消息未读数清零
     * @param {消息类型} type
     */
    async notification_unread_clear(type){
        let res = await this.sendget("account/user/notification_unread_clear/?type="+type)
        if(res.status) await this.notification_unread_count()
        return res
    }

    /**
     * 获取我的粉丝列表
     * @param {翻页时需要的参数，为当前列表的最后一个id；初始值为0} lastID
     */
    async my_follower_list(lastID){
        return await this.sendget("account/user/my_follower_list/?lastID="+lastID)
    }

    /**
     * 获取我的粉丝列表
     * @param {翻页时需要的参数，为当前列表的最后一个id；初始值为0} lastID
     */
    async my_buzz_article_list(lastID){
        return await this.sendget("account/user/my_buzz_article_list/?lastID="+lastID)
    }

    /**
     * send qqh
     * @param userID
     * @param touserID
     * @param msgbody
     */
    async sendQqh(touserID,msgbody){
        try{
            let data = {
                'touserID':touserID,
                'msgbody':msgbody
            };
            let res = await this.post("account/user/qqh_add/",data);
            // this.avatar = res.avatar
            return res
        }
        catch(e){
            // console.log(e);
            return false;
        }
    }
    /**
     * get qqh list
     */
    async qqh_list(lastID){
        return await this.get("account/user/qqh_list/?lastID="+lastID);
    }

    /**
     * get qqh view
     * @param qqhID
     */
    async qqh_view(qqhID,lastID){
        return await this.get("account/user/qqh_view/?qqhID="+qqhID+"&lastID="+lastID);
    }

    /**
     * 删除 qqh
     * @param qqhID
     */
    async qqh_delete(qqhID){
        return await this.get("account/user/qqh_delete/?qqhID="+qqhID);
    }

    /**
     * 获取我关注的人
     * @param {分页参数} lastID
     */
    async my_followering_list(lastID){
        // return await this.sendget("blog/user/my_followering_list/?lastID="+lastID);
        return await this.sendget("blog/user/my_following_list/?lastID="+lastID);
    }

    /**
     * 获取我关注的人的文章列表
     * @param {被我关注人的id，如果为0返回所有被关注者新文章} followingID
     * @param lastID
     */
    async following_article_list(followingID,lastID){
        return await this.sendget("blog/user/following_article_list/?followingID="+followingID+"&lastID="+lastID)
    }

    /**
     * 返回正文页内容
     * @param number id
     */
    async article_view(id){
        return await this.sendget("article/user/article_view/?id="+id)
    }

    /**
     * 发布新博客文章
     * @param {title:'文章标题',msgbody:'文章内容',tagname:[tag1,tag2],typeID:1(bolg模块为1)} article_data
     * @param {add:true,bloggerID:#,categoryID:#} module_data
     */
    async article_add(data){
        return await this.sendpost('article/user/article_add/',data)
    }
    /**
     * 编辑已发布的文章（已发布文章转草稿）
     * @param {*} id
     */
    async article_to_draft_by_postID(id){
        return await this.sendget('article/user/article_to_draft_by_postID/?id='+id)
    }
    // article/user/article_update

    /**
     * 发布编辑的已发布文章（已发布文章草稿转成发布状态）
     * @param {title:'文章标题',msgbody:'文章内容',tagname:[tag1,tag2],postID:0,typeID:1(bolg模块为1),draftID:0} article_data
     * @param {edit:true,bloggerID:#,categoryID:#} module_data
     */
    async article_update(data){
        return await this.sendpost('article/user/article_update/',data)
    }

    /**
     * 返回是否有草稿
     * @param number id - postID
     */
    async draft_check(postID){
        return await this.sendget("article/user/draft_check/?id="+postID)
    }
    /**
     * 返回草稿内容
     * @param number id - postID
     * @param number bloggerID - bloggerID
     */
    async draft_view(id,bloggerID){
        return await this.sendget("article/user/draft_view/?id="+id+"&bloggerID="+bloggerID)
    }

    /**
     * 删除目录中的草稿
     *
     * @param {postID}
     *          postID
     */
    async draft_delete(postID){
        return await this.sendget('article/user/draft_delete/?id='+postID)
    }

    /**
     * 草稿自动保存
     * @param {title:'文章标题',msgbody:'文章内容',tagname:[tag1,tag2],typeID:1(bolg模块为1),draftID:0} article_data
     * @param {edit:true,bloggerID:#,categoryID:#} module_data
     */
    async draft_update(data){
        return await this.sendpost('article/user/draft_update/',data)
    }

    /**
     * 创建草稿
     * @param {title:'文章标题',msgbody:'文章内容',tagname:[tag1,tag2],typeID:1(bolg模块为1),"is_comment":1,} article_data
     * @param {add:true,bloggerID:#,categoryID:#} module_data
     */
    async draft_add(data){
        return await this.sendpost('article/user/draft_add/',data)
    }

    /**
     * 快速发布草稿（快速发布已发布的文章草稿）
     * @param {*} draftID
     */
    async draft_to_article_by_draftID(draftID){
        return await this.sendget('article/user/draft_to_article_by_draftID/?draftID='+draftID)
    }

    /**
     * 文章设为私密/公开
     * @param {*} postID
     * @param {val=1 公开; 0 私密} is_publish
     */
    async article_publish(postID,val){
        return await this.sendget('article/user/article_publish/?postID='+postID+'&is_publish='+val)
    }

    /**
     * 文章禁止/允许评论
     * @param {*} postID
     * @param {val=1 公开; 0 私密} is_comment
     */
    async article_comment(postID,val){
        return await this.sendget('article/user/article_comment/?postID='+postID+'&is_comment='+val)
    }

    /**
     * 文章禁止/允许转载
     * @param {*} postID
     * @param {val=1 公开; 0 私密} is_share
     */
    async article_share(postID,val){
        return await this.sendget('article/user/article_share/?postID='+postID+'&is_share='+val)
    }

    /**
     * 返目录列表(作者)
     *
     * @param number
     *          $bloggerID
     */
    async category_list(bloggerID){
        return await this.sendget("blog/user/category_list/?bloggerID="+bloggerID)
    }
    /**
     * 定时发布
     * @param {*} draftID
     * @param {val=1 公开; 0 私密} is_timer
     * @param {time 与现在时间的时间差秒数} time
     */
    async article_timer(draftID,val){
        return await this.sendget('article/user/article_timer/?draftID='+draftID+'&is_timer='+is_timer+'&time='+time)
    }

    //关闭editor bubble
    /**
     *
     * @param {bubble类型字符串} type
     * @returns
     */
    async remove_bubble(type){
        return await this.sendget('account/user/user_bubble_update/?type='+type+'&visible=0')
    }

    /**
     * 獲取所属群博列表
     * @returns
     */
    async get_group_blog_list(){
        return await this.sendget('/blog/user/group_join_list/');
    }
    /**
     * 搜索用户
     * @param {*} keyword
     * @returns userlist
     */
    async public_search_user(keyword){
        return await this.sendget(`/search/page/users/?keyword=${keyword}`);
    }
    /**
     * 添加 group member
     * @param {*} userID
     * @returns
     */
    async group_member_add(userID){
        return await this.sendget(`/blog/user/group_member_add/?userID=${userID}`)
    }
    /**
     * 移除 group member
     * @param {*} userID
     * @returns
     */
    async group_member_delete(userID){
        return await this.sendget(`blog/user/group_member_delete/?userID=${userID}`)
    }
    /**
     * 获取 group member 列表
     *
     * @returns
     */
    async get_group_member(userID){
        return await this.sendget(`blog/page/group_member_list/?userID=${userID}`)
    }
    /**
     * 检查一组userid是否在我的关注列表里
     * @param {被关注人的userID，逗号分割} followingID
     * @returns
     */
    async my_follower_check(followingID){
        return await this.sendget(`account/user/my_follower_check/?followingID=${followingID}`)
    }

    // 管理员相关函数 ==================
    /**
     * 获取文章列表
     * @param lastID {列表最后一条id，用于分页；缺省为0}
     * */
    async admin_article_list(type,lastID){
        return await this.sendget("blog/admin/article_list/?lastID="+lastID+"&type="+type);
    }

    /**
     * 管理员推荐文章
     * @param postID {推荐文章的postID}
     * */
    async article_recommand_add(postID){
        return await this.sendget("blog/admin/article_recommand_add/?postID="+postID);
    }

    /**
     * 管理员取消推荐文章
     * @param postID {推荐文章的postID}
     * */
    async article_recommand_delete(postID){
        return await this.sendget("blog/admin/article_recommand_delete/?postID="+postID);
    }

    /**
     * 管理员修改文章标题
     * @param postID {推荐文章的postID}
     * @param title {标题文本}
     * */
    async article_recommand_update(postID,title){
        return await this.sendget("blog/admin/article_recommand_update/?postID="+postID+"&title="+title);
    }

    /**
     * 管理员查询用户
     * @param keyword {查询关键字}
     */
    async user_search(keyword){
        return await this.sendget("account/admin/user_search/?keyword="+keyword);
    }
    /**
     * 管理员以此用户身份登录
     * @param userID {用户id}
     */
    async login_status(userID){
        return await this.sendget("account/admin/login_status/?userID="+userID);
    }
    /**
     * 管理员封禁用户
     * @param userID {用户id}
     * @param status {0:封禁；1:解封}
     */
    async user_delete(userID,status){
        return await this.sendget("account/admin/user_delete/?userID="+userID+'&status='+status);
    }

    /**
     * 管理员查询评论
     * @param {主贴postID} id
     * @param {评论最后一个postID} lastID
     */
    async article_view_comment(id,lastID){
        return await this.sendget("blog/admin/article_view_comment/?id="+id+"&lastID="+lastID)
    }

    /**
     * 管理员删除/恢复评论
     * @param {评论的postID} id
     * @param {0:删除; 1:恢复} visible
     * @returns
     */
    async admin_reply_delete(id,visible){
        return await this.sendget("article/user/reply_delete/?id="+id+"&visible="+visible)
    }

    /**
     * 管理员删除/恢复文章
     * @param {文章的postID} postID
     * @param {0:删除; 1:恢复} visible
     * @returns
     */
    async admin_article_delete(postID,visible){
        return await this.sendget("article/user/article_delete/?postID="+postID+"&visible="+visible)
    }

    /**
     * 管理员获取文学城首页列表 /blog/admin/article_wxc_homgepage_list
     * @returns
     */
    async admin_wxc_homgepage_list(){
        return await this.sendget("/blog/admin/article_wxc_homgepage_list/")
    }

    /**
     * 管理员 删除/恢复 文学城首页文章 /blog/admin/article_wxc_homgepage_delete
     * @param {文章的postID} postID
     * @param {0:删除; 1:恢复} visible
     * @returns
     */
    async admin_wxc_homgepage_delete(postID,visible){
        return await this.sendget(`/blog/admin/article_wxc_homgepage_delete/?postID=${postID}&visible=${visible}`)
    }

    /**
     * 管理员 推文章到文学城首页
     * @param {*} postID
     * @returns
     */
    async wxc_hot_blog_add(postID){
        return await this.sendget(`/blog/admin/wxc_hot_blog_add/?postID=${postID}`)
    }

    /**
     * 管理员 从文学城首页撤下该文章
     * @param {*} postID
     * @returns
     */
    async wxc_hot_blog_delete(postID){
        return await this.sendget(`/blog/admin/wxc_hot_blog_delete/?postID=${postID}`)
    }

    /**
     * 检测文章是否在文学城首页
     * @param {*} postID
     * @returns
     */
    async wxc_hot_blog_check(postID){
        return await this.sendget(`/blog/admin/wxc_hot_blog_check/?postID=${postID}`)
    }
// 公用函数
    async sendget(url){
        try{
            let rs = await this.get(url);
            return rs;
        }
        catch(e){
            console.log(e)
            return false;
        }
    }

    async sendpost(url,data){
        try{
            let rs = await this.post(url,data);
            return rs;
        }
        catch(e){
            console.log(e)
            return false;
        }
    }
}

export default User
